export const OrnamentDivider = ({ className = "" }) => (
  <img src="/brand/ornament-divider.svg" alt="" aria-hidden="true"
    className={`block mx-auto w-[180px] h-auto ${className}`} data-testid="ornament-divider" />
);

export const Monogram = ({ size = 48, className = "" }) => (
  <img src="/brand/monogram-dwg.svg" alt="Monogram Dessy Wedding Group" width={size} height={size}
    className={className} style={{ width: size, height: size }} />
);

export const ArchPhoto = ({ src, alt, className = "", children }) => (
  <div className={`arch ${className}`}>
    <div className="arch-inner">{children || <img src={src} alt={alt} loading="lazy" />}</div>
  </div>
);

export const PackageImage = ({ src, alt, category, className = "" }) => (
  src ? (
    <img src={src} alt={alt} loading="lazy" className={`w-full h-full object-cover ${className}`} />
  ) : (
    <div className="w-full h-full bg-[var(--bg-alt)] flex flex-col items-center justify-center gap-2" data-testid="pkg-placeholder">
      <Monogram size={64} />
      {category && <span className="eyebrow">{category}</span>}
    </div>
  )
);
